"use strict";
function isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
exports.isPromise = isPromise;
//# sourceMappingURL=isPromise.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/util/isPromise.js
 ** module id = 481
 ** module chunks = 0
 **/